import React from 'react'
import PropTypes from 'prop-types'
import Image from '../Image'
import getCurrentDomain from '../../utils/getCurrentDomain'
import styles from './styles'

const PaywallNotice = ({
  logo,
}) => {
  const domain = `.${getCurrentDomain()}`

  const handleLearnMoreButton = () => {
    window.location.href = `https://player${domain}/player-plus-premier-sports`
  }

  const content = (
    <div className={`concurrent-stream-notice`}>
      <div className={`device-image-outer`}>
        <div className="logos-container">
          <img
            src={require('./stv_ps_logo.png')}
            alt="STV PremSportsLogo"
            width="200"
            height="33"
          />
          {(Object.keys(logo).length !== 0) && (
            <div className="channel-logo" data-testid="channel-logo">
              <Image
                image={logo}
                alt="PremSportsLogo"
              />
            </div>
          )}
        </div>
      </div>
      <React.Fragment>
        <div className="wrap">
          <h2 className="paywall-title">DISCOVER PREMIER SPORTS CONTENT <br />WITH STV PLAYER+</h2>
        </div>
        <ul style={{ margin: '0px auto', textAlign: 'center', padding: 0 }}>
          <li>Live Scottish football & European rugby</li>
          <li>On-demand highlights & full game replays</li>
          <li>Stream 1000s of hours ad-free<sup>1</sup></li>
        </ul>

        <div className="button-wrap">
          <button
            type="button"
            className="upgrade-button"
            data-testid="upgrade-button"
            onClick={handleLearnMoreButton}
          >
            Learn more
          </button>
        </div>
        <p style={{ textAlign: 'center', fontSize: '12px', padding: 0 }}><sup>1</sup> Excludes live channels and selected shows for contractual reasons.</p>
      </React.Fragment>
      <style jsx>{styles}</style>
    </div>
  )

  return content
}

PaywallNotice.propTypes = {
  logo: PropTypes.object,
}

PaywallNotice.defaultProps = {
  logo: {},
}

export default PaywallNotice
